import { useEffect } from "react";

export default function TribeRedirect() {
  useEffect(() => {
    window.location.replace("https://tribe-mail-feature.emergent.host");
  }, []);

  // Show loading message while redirecting
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#030303', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      color: '#888'
    }}>
      <p>Redirecting to TRIBE...</p>
    </div>
  );
}
